// routes
import {paths} from 'packages/common/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

// URLs pour les différentes applications
export const DASHBOARD_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://my.brydge.app';
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL || 'https://go.brydge.app';
export const WIDGETS_URL = process.env.REACT_APP_WIDGETS_URL || 'https://widgets.brydge.app';

// Maintien de FRONTEND_URL pour compatibilité avec le code existant
// Idéalement, vous devriez utiliser DASHBOARD_URL ou PUBLIC_URL directement selon le contexte
export const FRONTEND_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://my.brydge.app';

// ROOT PATH AFTER LOGIN SUCCESSFUL
/* export const PATH_AFTER_LOGIN = paths.app.root; // as '/app/dashboard' */

// Route par défaut vers la page de login
export const DEFAULT_PATH = paths.auth.login;
